import React, { useState, useEffect } from 'react'
import styles from '../style.module.css';
import { BreathAPIs } from '../../APIs/BreathAPIs';


function BookingCancel({ history, timeFormatAmPm }) {

    const [showMore, setShowMore] = useState(false)
    const [billingData, setBillingData] = useState ()
    const [taxCost, setTaxCost] = useState(0)

    const getFormattedDate = (timestamp) => {
        const date = new Date(timestamp);
        const newDate = date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: '2-digit',
            hour12: timeFormatAmPm,
        });
        return newDate;
    }

    const getBillingData = async () =>{
        if (history.booking && history?.bookingCancel === false){
            const data = await BreathAPIs.getBilling(history.booking._id);
            setBillingData(data.data)
            setTaxCost(data.data.taxCost ? data.data.taxCost : 0)
        }
        
    }
    useEffect(()=>{
        getBillingData();
    },[])
 
    return (
        <div>
            {history?.booking && !history?.bookingCancel && <div onClick={()=>{setShowMore(!showMore)}} className={styles['booking-canceled-show-more']}>{showMore ? 'Hide' : 'Show more'}</div>}
            {showMore && !history.bookingCancel && <div className={styles['booking-canceled']}> 
                <h6 className='text-center'>Metered Energy Bill</h6>
                <div>Utilized Energy: <span>{history.booking.utilizedEnergy?.toFixed(4)}kWh</span></div>
                <div>Idle Cost: <span>${billingData?.IdleCost ? billingData?.IdleCost.toFixed(2) : '0.00'}</span></div>
                <div>Energy Cost: <span>${(history.booking.totalCost?.toFixed(2) - history.booking.unUtilizedFee?.toFixed(2) - taxCost?.toFixed(2))?.toFixed(2)}</span></div>
                <div>Tax({billingData?.taxPercent ? billingData.taxPercent : '0'}%) <span>${billingData?.taxCost ? taxCost?.toFixed(2) : '0.00'}</span></div>
                { 
                    history.booking.nonReservable ?   (
                        history.booking.nonReservable === true ?  <></>  : <div>Unutilized Time Fee : <span>${history.booking.unUtilizedFee?.toFixed(2)}</span></div>
                    )
                      : <div>Unutilized Time Fee : <span>${history.booking.unUtilizedFee?.toFixed(2)}</span></div>
                    
                }
                {
                    history.booking.isNightCharging && <div>Overnight Fee: <span>${history.booking.nightChargeEstimate >= 0 ? history.booking.nightChargeEstimate?.toFixed(2) : "0.00"}</span></div>
                }
                

                <div>Start time : <span>{getFormattedDate(new Date(history.booking.startTime))}</span></div>
                <div>End Time: <span>{getFormattedDate(new Date(history.booking.endTime))}</span></div>

                
                {/* <div className={styles['data-row']}>Energy Cost<span>${(totalCost - unUtilizedFee - taxCost).toFixed(2)}</span></div> {(totalCost - unUtilizedFee - taxCost).toFixed(2)} */}
            </div>} 
            
            {history?.bookingCancel && <div className={styles['booking-canceled']}> 
                <h6 className='text-center' style={{marginBottom:0}}>Cancellation fee</h6>
                {/* <div>Utilized Energy: <span>{history.booking.utilizedEnergy}kWh</span></div>
                <div>Idle Cost: <span>${history.booking.IdleDuration * 0.25}</span></div>
                <div>Energy Cost: <span>${(history.booking.totalCost.toFixed(2) - history.booking.unUtilizedFee.toFixed(2)).toFixed(2)}</span></div>
                <div>Unutilized Fee : <span>${history.booking.unUtilizedFee.toFixed(2)}</span></div>
                <div>Start time : <span>{getFormattedDate(new Date(history.booking.startTime))}</span></div>
                <div>End Time: <span>{getFormattedDate(new Date(history.booking.endTime))}</span></div> */}
            </div> }   
        </div>

    )
}


export default BookingCancel;